import React, { useContext, useEffect, useState } from 'react'
import { Card, Image } from 'react-bootstrap'
import AppModal from '@/components/common/AppModal'
import { logos } from '@/utils/publisher-logos-theme'
import LogoDark from '@/assets/images/logo-dark-new.png'
import LogoLight from '@/assets/images/logo-light-new.png'
import { SettingsContext } from '@/context/settings-context'

const ModalContent = ({ theme, selected, setSelected, publisher }) => {
    return (
        <>
            <div className={`mb-4 mt-4 text-center ${theme === 'dark' ? 'text-white' : 'text-dark'}`}>
                Please select account type
            </div>
            <div className="d-flex justify-content-center gap-4 flex-wrap">
                <Card
                    className="tw:hover:!bg-transparent tw:!border-slate-800 tw:!cursor-auto account-card text-center d-flex p-5 justify-content-center border-1 shadow-sm position-relative tw:items-center"
                    // onClick={() => setSelected('system')} can not select system account for media buying
                    role="button"
                >
                    {/*<div className={`grayscale-0 card-overlay ${selected === 'system' ? 'overlay-active' : ''}`} />*/}
                    <div className="mb-3 position-relative z-2">
                        <Image src={theme === 'dark' ? LogoDark : LogoLight} alt="Turba" style={{ height: '80px' }} />
                    </div>
                    <div className="tw:text-slate-500 fw-semibold position-relative z-2" style={{ fontSize: '14px' }}>
                        Use Turba Media Account
                    </div>
                    <div
                        className="tw:text-slate-500  small position-relative z-2 mb-3 mt-2"
                        style={{ fontSize: '12px' }}
                    >
                        If you don't have Meta ad account
                    </div>
                    <div>
                        <input
                            type="radio"
                            id="turba"
                            name="drone"
                            disabled={true}
                            checked={selected === 'system'}
                            onChange={() => setSelected('system')}
                            className="tw:color-slate-700"
                            style={{ height: '16px', width: '16px', cursor: 'none' }}
                        />
                    </div>
                </Card>

                <Card
                    className="account-card text-center d-flex p-5 justify-content-center border-1 shadow-sm position-relative card-hover-overlay tw:items-center"
                    onClick={() => setSelected(publisher)}
                    role="button"
                >
                    <div className={`tw:!rounded-xs card-overlay ${selected === publisher ? 'overlay-active' : ''}`} />
                    <div className="mb-3 position-relative z-2">
                        <Image
                            src={logos[publisher] ? logos[publisher][theme] : '/path/to/meta-logo.png'}
                            alt="Meta"
                            style={{ height: '80px' }}
                        />
                    </div>
                    <div className="fw-semibold position-relative z-2" style={{ fontSize: '14px' }}>
                        Use Meta Ad Account
                    </div>
                    <div className="small position-relative z-2 mb-3 mt-2" style={{ fontSize: '12px' }}>
                        Use your own account
                    </div>
                    <div>
                        <input
                            type="radio"
                            id="meta"
                            name="drone"
                            checked={selected === publisher}
                            onChange={() => setSelected(publisher)}
                            style={{ height: '16px', width: '16px', cursor: 'pointer' }}
                        />
                    </div>
                </Card>
            </div>
        </>
    )
}

const AccountChoiceModal = ({ publisher, show, onCancel, onConfirm }) => {
    const [selected, setSelected] = useState(null)
    const { theme } = useContext(SettingsContext)

    useEffect(() => {
        document.body.classList.remove('light', 'dark')
        document.body.classList.add(theme)
    }, [theme])

    const handleConfirm = () => {
        if (!selected) return
        onConfirm(selected)
    }

    const handleCancel = () => {
        setSelected(null)
        onCancel()
    }

    return (
        <AppModal
            show={show}
            title="Select Account Type"
            onCancel={handleCancel}
            onConfirm={handleConfirm}
            confirmDisabled={!selected}
            theme={theme}
        >
            <ModalContent theme={theme} selected={selected} setSelected={setSelected} publisher={publisher} />
        </AppModal>
    )
}

export default AccountChoiceModal
